<template>
    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0.63 4.136L4.074 0.692L4.476 1.112C4.56 1.2 4.594 1.288 4.578 1.376C4.562 1.46 4.514 1.542 4.434 1.622L2.838 3.212C2.634 3.416 2.452 3.578 2.292 3.698C2.508 3.67 2.734 3.648 2.97 3.632C3.21 3.616 3.456 3.608 3.708 3.608H11.304V4.676H3.708C3.456 4.676 3.21 4.668 2.97 4.652C2.734 4.636 2.508 4.614 2.292 4.586C2.372 4.654 2.456 4.728 2.544 4.808C2.636 4.884 2.734 4.972 2.838 5.072L4.446 6.674C4.526 6.754 4.574 6.838 4.59 6.926C4.606 7.01 4.572 7.096 4.488 7.184L4.086 7.604L0.63 4.136Z"
			class="fill-current"
        />
    </svg>
</template>
